


































































































































































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import PageLayout from '@/components/page/PageLayout.vue'
import riskSection from '@/views/AiiTasks/riskSection.vue'
import DetailHeaderBtns from '@/components/task/DetailHeaderBtns.vue'
import AuditTabs from './AuditTabs.vue'
import SuperTabs from '@/views/AiiTasks/SuperTabs.vue'
import TaskDetailMixins from '@/mixins/taskDetail'
import AuditApi from '@/api/audit'
import TaskApi from '@/api/task'
import { DAI_CHU_SHEN } from '@/web-task/config.ts'
import Task from '@/web-task'
import { formatTime, formatDate, format } from '@/web-task/filter'
@Component({
	name: 'returnVisitAuditDetail',
	components: {
		PageLayout,
		riskSection,
		DetailHeaderBtns,
		AuditTabs,
		SuperTabs,
	},
})
export default class QueryList extends Mixins(TaskDetailMixins) {
	private canCreateConciliationOrder: boolean = false

	private DAI_CHU_SHEN = DAI_CHU_SHEN
	private returnVisible: boolean = false
	private returnForm: any = {}
	private returnLoading: boolean = false
	private visiblePass: boolean = false
	private passForm: any = {}
	private created() {
		this.returnForm = this.$form.createForm(this)
		this.passForm = this.$form.createForm(this)
	}
	private getEx(data: any) {
		this.canCreateConciliationOrder = data.canCreateConciliationOrder
	}

	private toAddMediate() {
		// this.$ss.set('mediateOrderId', this.$route.params.orderId)
		this.$router.push({
			name: `addOfflineMediate`,
			params: { orderId: this.$route.params.orderId },
		})
	}

	// 审核通过、审核驳回的前置校验
	private beforeClick() {
		// 校验信息
		const auditTabs: any = this.$refs.auditTabs
		// @ts-ignore
		const result = auditTabs.validateFormData()
		return result
	}

	// 保存编辑信息
	private saveAudit() {
		// 等待订单数据加载
		if (!this.order) {
			this.$message.info('请等待订单数据加载完')
			return
		}
		const task = new Task({
			propsData: {
				order: this.order,
				injured: this.injured,
				boardImageList: this.boardImageList,
				setting: this.$store.state.setting,
			},
		})
		// 校验信息
		const auditTabs: any = this.$refs.auditTabs
		let editForm = auditTabs.getFormData()
		if (!editForm.injured.selfPhone && !editForm.injured.phone) {
			this.$message.error('请填写伤者电话与家属电话其中一项')
			return
		}
		if (!editForm.injured.selfPhone && editForm.injured.phone0 == '') {
			this.$message.error('请填写伤者电话与家属电话其中一项')
			return
		}
		let isWorkTime = 0
		for (const iterator of editForm.work.workInfoList) {
			if (iterator.beginDate && iterator.endDate) {
				isWorkTime += this.time(iterator.beginDate, iterator.endDate, 'day')
			}
		}
		if (isWorkTime < 365 && editForm.work.hasWork == '1') {
			this.$message.error('请填写至少超过一年的工作经历')
			return
		}
		let islivingTime = 0
		for (const iterator of editForm.livingInfoList) {
			if (iterator.beginDate && iterator.endDate) {
				islivingTime += this.time(iterator.beginDate, iterator.endDate, 'day')
			}
		}
		if (islivingTime < 365) {
			this.$message.error('请填写至少超过一年的居住经历')
			return
		}
		// @ts-ignore
		const result = auditTabs.validateFormData()
		// console.log(result, 'result')
		if (result) {
			// 通过校验则获取表单数据并提交
			const formData = auditTabs.getFormData()
			formData.orderId = this.$route.params.orderId
			console.log(formData)
			AuditApi.saveAudit(formData).then((data: any) => {
				if (data.code === 200) {
					this.$message.success('保存成功')
				} else if (data.code === 503 && data.message === '权限不足，操作非法') {
					this.$store.dispatch('user/Logout').then(() => {
						window.location.replace(`${location.origin}/passport/login`)
					})
				} else {
					this.$notification.error({
						message: '错误',
						description: data.message,
					})
				}
			})
		}
	}

	private time(date1: any, date2: any, type: any) {
		date1 = typeof date1 == 'string' ? new Date(date1) : date1
		date1 = date1.getTime()
		date2 = typeof date2 == 'string' ? new Date(date2) : date2
		date2 = date2.getTime()
		type = type || 'hour'
		let diffValue = Math.abs(date2 - date1)
		let second = 1000,
			minute = second * 60,
			hour = minute * 60,
			day = hour * 24,
			month = day * 30,
			year = month * 12
		let timeType: any = {
			second: second,
			minute: minute,
			hour: hour,
			day: day,
			month: month,
			year: year,
		}
		return Math.ceil(diffValue / timeType[type])
	}

	private get canChecked() {
		return this.$route.query.canChecked === '1'
	}
	private insufficiencyChange(e: any) {
		this.passForm.insufficiency = e.target.value
	}
	private handleCancel() {
		this.visiblePass = false
	}
	private handleOk() {
		this.passForm.validateFields((err: any, values: any) => {
			if (!err) {
				return TaskApi.checkTask({
					orderId: this.$route.params.orderId,
					pass: '1',
					insufficiency: values.insufficiency,
					insufficiencyRemark: values.insufficiencyRemark,
				}).then((res: any) => {
					this.visiblePass = false
					this.$message.success('审核通过成功')
					this.$store.dispatch('user/getCountInfo')
					setTimeout(() => {
						this.$router.replace('/returnVisit/auditList')
					}, 1000)
				})
			}
		})
	}
	private chcekPass() {
		if (this.order.insufficiency != '1') {
			this.visiblePass = true
		} else {
			this.$confirm({
				title: '提示',
				content: '确认审核通过吗 ?',
				onOk: () => {
					return TaskApi.checkTask({
						orderId: this.$route.params.orderId,
						pass: '1',
					}).then((res: any) => {
						this.$message.success('审核通过成功')
						this.$store.dispatch('user/getCountInfo')
						setTimeout(() => {
							this.$router.replace('/returnVisit/auditList')
						}, 1000)
					})
				},
			})
		}
	}

	private auditTaskReturn() {
		this.returnForm.resetFields()
		this.returnVisible = true
	}
	private returnOk() {
		this.returnForm.validateFields((err: any, values: any) => {
			if (!err) {
				this.returnLoading = true
				if (this.order.orderStatus === '04') {
					TaskApi.auditTask({
						id: this.order.operationId,
						orderId: this.$route.params.orderId,
						status: '01',
						orderStatus: '02',
						comment: values.comment,
					})
						.then((res: any) => {
							this.returnVisible = false
							this.$message.success('审核退回成功')
							setTimeout(() => {
								this.$router.replace('/returnVisit/auditList')
							}, 1000)
						})
						.finally(() => {
							this.returnLoading = false
						})
				} else if (this.order.orderStatus === '031') {
					TaskApi.checkTask({
						orderId: this.$route.params.orderId,
						pass: '0',
						comment: values.comment,
					})
						.then((res: any) => {
							this.returnVisible = false
							this.$message.success('审核退回成功')
							setTimeout(() => {
								this.$router.replace('/returnVisit/auditList')
							}, 1000)
						})
						.finally(() => {
							this.returnLoading = false
						})
				}
			}
		})
	}
}
